export const SOUND_PATHS = {
  newMember: "/audio/NEWMEMBER.mp3",
  newAbuse: "/audio/NEWABUSE.mp3",
  bankIn: "/audio/BANKIN.mp3",
  bankOut: "/audio/BANKOUT.mp3",
  accountNo: "/audio/ACCOUNTNO.mp3",
  newMessage: "/audio/NEW_MESSAGE.mp3",
};

export function getSoundPathCandidates(soundKey) {
  const path = SOUND_PATHS[soundKey];
  return path ? [path] : [];
}
